import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import sr from "./sr.json";
import en from "./en.json";

// Multilanguage setup za BusGo customer app.
// Default jezik: srpska latinica. Drugi: engleski.
// Detekcija: samo localStorage (korisnikov izbor) → inače 'sr' fallback.
// Namerno BEZ 'navigator' — da jezik browsera (npr. engleski) ne pretekne srpski
// pri prvom otvaranju; engleski se bira tek ako ga korisnik ručno izabere.

const SUPPORTED = ["sr", "en"];
const LANG_KEY = "busgo_lang";

// Pri prvom otvaranju jezik se odmah usidri na srpski — i18next sam upisuje izbor
// tek kad ga korisnik promeni, pa bi do tada ključ ostao prazan. Regionalne
// varijante („sr-Latn-RS", „en-US") svode se na osnovni kod, a sve van liste na srpski.
try {
    const saved = localStorage.getItem(LANG_KEY);
    const base = saved ? saved.substring(0, 2).toLowerCase() : "";
    localStorage.setItem(LANG_KEY, SUPPORTED.includes(base) ? base : "sr");
} catch (e) {
    // Privatni režim bez localStorage — ostaje fallbackLng ispod.
}

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            sr: { translation: sr },
            en: { translation: en },
        },
        fallbackLng: "sr",
        supportedLngs: SUPPORTED,
        interpolation: { escapeValue: false }, // React već escape-uje
        detection: {
            order: ["localStorage"],
            lookupLocalStorage: "busgo_lang",
            caches: ["localStorage"],
        },
        // Ako ključ nedostaje u prevodu, prikazuje sam ključ (lakše za debug).
        returnNull: false,
        returnEmptyString: false,
    });

export default i18n;
